import React from "react";
import { toast } from "react-hot-toast";
import AccountForm from "../../components/forms/account-form";
import Header from "../../components/header";
import { useAuth } from "../../contexts/AuthContext";
import {
  EditAccountFormValues,
  useEditAccountForm,
} from "../../forms/account/edit-account-form";
import { Account } from "../../models/account";

export default function EditAccount() {
  const { account, editAccount } = useAuth();
  const editAccountForm = useEditAccountForm(account as Account);

  const onRegisterSubmit = async (values: EditAccountFormValues) => {
    await toast.promise(
      editAccount(values),
      {
        loading: "Saving...",
        success: <b>Account data changed successfully!</b>,
        error: (e) => {
          return e?.response?.data
            ? e.response.data
            : e.message ?? "An Error Occurred.";
        },
      },
      { duration: 5000 }
    );
  };

  return (
    <>
      <Header>
        <div className="container w-full mx-auto">
          <div className="container h-[80px] mx-auto text-3xl text-white font-semibold flex items-center">
            Edit Account
          </div>
        </div>
      </Header>
      <AccountForm
        onSubmit={onRegisterSubmit}
        form={editAccountForm}
        mode="edit"
      />
    </>
  );
}
